import * as React from 'react'
import { ResultCardData } from '.'

import ResultCardCtaMenu from './result-card-cta-menu'
import ResultCardCtaSingle from './result-card-cta-single'

import { VBox } from '../../elements/basic-elements'
import { getActionCtaIconByCategory, getActionCtaLabelByCategory } from '../../constants/actions'

export type ResultCardCtaProps = {
  actionIsCompleted: boolean
  data: ResultCardData
  onClickthrough: () => void
}

const ResultCardCta = (props: ResultCardCtaProps) => {
  // until we get rid of the legacy Every donation portion of the Action document
  // we need to create a workaround for combining existing Every donations into
  // our multi-select cta component when it exists

  const data = props.data.donation?.organization
    ? {
        ...props.data,
        contributions: [
          ...(props.data.contributions?.length > 0
            ? props.data.contributions
            : // add the default action as a contribution instead
              // if contributions don't exist on a legacy action, we have to
              [
                {
                  type: 'standard',
                  defaultDetails: {
                    type: props.data.categories[0],
                    url: props.data.url
                  }
                }
              ]),
          {
            type: 'everyDonation',
            everyDetails: props.data.donation
          }
        ]
      }
    : props.data

  const hasMultipleButtons = data.contributions?.length > 0
  const firstCategory = data.categories[0]

  return (
    <VBox height="100%">
      {hasMultipleButtons ? (
        <ResultCardCtaMenu {...props} data={data as ResultCardData} />
      ) : (
        <ResultCardCtaSingle
          isCompleted={props.actionIsCompleted}
          onClick={() => {
            data.url && window.open(data.url, '_blank')
            props.onClickthrough()
          }}
          label={getActionCtaLabelByCategory(firstCategory)}
          icon={getActionCtaIconByCategory(firstCategory)}
        />
      )}
    </VBox>
  )
}

export default ResultCardCta
